import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const PromoWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: ${({ theme }) =>
    theme.colors.promobannerBackground || theme.colors.secondary};
  color: ${({ theme }) =>
    theme.colors.promobannerText || theme.colors.bodyText};
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  display: flex;
  align-items: center;
  a {
    color: ${({ theme }) =>
      theme.colors.promobannerLinkColor || theme.colors.bodyText};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: auto;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    visibility: ${({ $scrollDisable }) =>
      $scrollDisable ? "visible" : "hidden"};
    transition: max-height 0.3s ease-in-out;
    max-height: ${({ $scrollDisable }) => ($scrollDisable ? "30px" : "0px")};
  }
`;
const InnerWrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const TextDiv = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  padding: 10px;
  p {
    margin: 0;
    font-size: 0.8rem;
    font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  }
`;
const CloseButton = styled.button`
  color: ${({ theme }) =>
    theme.colors.promobannerIcon || theme.colors.bodyText};
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 5px;
`;

const PromoBanner = ({ promoEnabled, promoText, scrollDisable }) => {
  const [isHidden, setHidden] = useState(true);
  function hidePromoBanner() {
    setHidden(true);
    localStorage.setItem("promoBanner", isHidden);
    const date = new Date();
    date.setDate(date.getDate() + 14);
    localStorage.setItem("promo-banner-expire", date);
  }
  useEffect(() => {
    const date = localStorage.getItem("promo-banner-expire");
    const newDate = new Date();
    if (date < newDate) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  });
  return (
    <>
      {promoEnabled && !isHidden && (
        <PromoWrapper
          $scrollDisable={scrollDisable}
          className={`active ${scrollDisable && "hidden"}`}
        >
          <InnerWrapper>
            <TextDiv
              dangerouslySetInnerHTML={{
                __html: promoText,
              }}
            />
            <CloseButton
              onClick={hidePromoBanner}
              aria-label="Lukk kampanjebanner"
            >
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </InnerWrapper>
        </PromoWrapper>
      )}
    </>
  );
};

export default PromoBanner;

PromoBanner.propTypes = {
  promoEnabled: PropTypes.bool,
  promoText: PropTypes.string,
  scrollDisable: PropTypes.bool,
};
